import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
  get,
} from "helpers/api_helper"
import {
  DELETE_SCHEDULE_NOTIFICATION,
  GET_ALL_PUSH_NOTIFICATIONS,
  GET_NOTIFICATION_HISTORY,
  GET_PUSH_NOTIFICATION_DETAILS,
  SEND_NOTIFICATION,
  UPDATE_PUSH_NOTIFICATION,
  UPDATE_PUSH_NOTIFICATION_STATUS,
} from "helpers/url_helper"

export const getAllPushNotifications = createAsyncThunk(
  GET_ALL_PUSH_NOTIFICATIONS,
  async payload => {
    const response = await post(GET_ALL_PUSH_NOTIFICATIONS, payload)
    return response
  }
)

export const updatePushNotificationStatus = createAsyncThunk(
  UPDATE_PUSH_NOTIFICATION_STATUS,
  async payload => {
    const response = await patch(UPDATE_PUSH_NOTIFICATION_STATUS, payload)
    return response
  }
)

export const getPushNotificationDetails = createAsyncThunk(
  GET_PUSH_NOTIFICATION_DETAILS,
  async payload => {
    const response = await post(GET_PUSH_NOTIFICATION_DETAILS, payload)
    return response
  }
)

export const updatePushNotification = createAsyncThunk(
  UPDATE_PUSH_NOTIFICATION,
  async payload => {
    const response = await put(UPDATE_PUSH_NOTIFICATION, payload)
    return response
  }
)

// SEND NOTIFICATION

export const sendNotification = createAsyncThunk(
  SEND_NOTIFICATION,
  async payload => {
    const response = await post(SEND_NOTIFICATION, payload)
    return response
  }
)

export const getNotificationHistory = createAsyncThunk(
  GET_NOTIFICATION_HISTORY,
  async payload => {
    const response = await post(GET_NOTIFICATION_HISTORY, payload)
    return response
  }
)

export const deleteScheduleNotification = createAsyncThunk(
  DELETE_SCHEDULE_NOTIFICATION,
  async payload => {
    // const URL = `${DELETE_SCHEDULE_NOTIFICATION}:${payload.id}`
    const req = { id: payload.id, status: payload.status }

    const response = await del(
      `${DELETE_SCHEDULE_NOTIFICATION}/${payload.id}`,
      req
    )
    return response
  }
)
